/**
 * Creates a set of operations for manipulating a string within a state object
 *
 * @param key - The key of the state object that contains a string
 * @returns A function that takes state and setState function and returns an object with string operations
 *
 * @example
 * // Types are inferred automatically
 * const queryOps = createStringOperationsFor('searchQuery')(state, setState)
 */
export function createStringOperationsFor<K extends string>(key: K) {
  return <S extends Record<K, string>>(
    state: S,
    setState: (updater: (prev: S) => S) => void,
  ) => {
    return {
      value: state[key],
      set: (value: string) => {
        setState(
          (prev) =>
            ({
              ...prev,
              [key]: value,
            } as S),
        )
      },
    }
  }
}
